import React from 'react'
import { Helmet } from 'react-helmet'
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only'

import WhiteLabelLayout from 'custom/layouts/WhiteLabel'
import { WhiteLabelProvider } from 'providers/WhiteLabelProvider'
import { IS_BROWSER } from 'src/localConstants'

export const wrapPageElement = ({ element, props }) => {
  const { location } = props
  const pathIs = (path) => location.pathname === path
  const isWidget = pathIs('/widget/')
  const hasWidget = pathIs('/test-widget/') || pathIs('/widget-instructions/')

  return (
    <>
      {/* Widget test pages */}
      {hasWidget && element}

      {/* Widget page */}
      {isWidget && IS_BROWSER && (
        <WhiteLabelProvider location={location} needsToAcceptTerms={!isWidget}>
          <Helmet
            defaultTitle="Powered by Tivity Health"
            titleTemplate="%s | Powered by Tivity Health"
          />
          {element}
        </WhiteLabelProvider>
      )}

      {/* Everything else */}
      {!isWidget && !hasWidget && (
        <WhiteLabelProvider location={location} needsToAcceptTerms={!isWidget}>
          <Helmet
            defaultTitle="Powered by Tivity Health"
            titleTemplate="%s | Powered by Tivity Health"
          />
          <WhiteLabelLayout {...props}>{element}</WhiteLabelLayout>
        </WhiteLabelProvider>
      )}
    </>
  )
}
